var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-sidebar',{attrs:{"bg-variant":_vm.bgVariant,"id":_vm.id,"no-header":"","shadow":_vm.shadow,"width":_vm.width},on:{"hidden":_vm.hide,"shown":_vm.show}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }